export default class SuccessRateScopeModel {
  public competitions: string[] = [];
  public teams: string[] = [];
  public markets: string[] = [];
}
